<template>
  <div class="col-12">
    <div class="row res-container">
      <div class="col-12">

          <div class="mask mask-header">
            <div>
              <div class="col-1-sm">
                Σ
              </div>
              <div class="col-8-sm">
                name
              </div>
              <div class="col-3-sm">
                s<b>m</b>l
              </div>
            </div>
          </div>
        <div class="row">
          <div class="mask" v-for="(mask, i) in masks" v-bind:key="updated + i">
            <div v-if="i == 0 || (masks[i-1].name != masks[i].name)">
              <div class="col-1-sm mask-total" >
                <span>
                  {{totalInList(mask.name).total}}
                </span>
              </div>
              <div class="col-8-sm mask-name">
                <span>{{mask.name}}</span>
              </div>
              <div class="col-3-sm">

                  <span v-if="totalInList(mask.name).s > 0">
                    {{totalInList(mask.name).s}}
                  </span>
                  <span v-else>
                    0
                  </span>

                  <span v-if="totalInList(mask.name).m > 0">
                    <b>{{totalInList(mask.name).m}}</b>
                  </span>
                  <span v-else>
                    <b>0</b>
                  </span>

                  <span v-if="totalInList(mask.name).l > 0">
                    {{totalInList(mask.name).l}}
                  </span>
                  <span v-else>
                    0
                  </span>
              </div>
            </div>
            <!-- <div class="col-2-sm">
            </div>
            <div class="col-10-sm">
            </div>
            <div class="col-1-sm mask-size">{{mask.size}}</div>
            <div class="col-1-sm mask-type">
              <span v-if="mask.type == 'string'">
                <font-awesome-icon :icon="['fa', 'signature']" />
              </span>
              <span v-else>
                <font-awesome-icon :icon="['fa', 'head-side-mask']" />
              </span>
            </div> -->
          </div>
        </div>
        <div class="row res-header">
          <div class="col-10-sm total-label">
            Total:
          </div>
          <div class="col-2-sm total">
            {{masks.length}}
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {reservationsRef} from '../../../firebase/firebaseConfig.js'
export default {
  name: 'ReservationCard',
  props: {
    masks: Array,
    i: Number,
    updated: Number
  },
  mounted() {
  },
  data: function (){
    return {
    }
  },
  methods: {
    totalInList(name) {
      let groupedMasks = this.masks.filter(mask => {return mask.name == name})
      let s = groupedMasks.filter(mask => { return mask.size == 's'})
      let m = groupedMasks.filter(mask => { return mask.size == 'm'})
      let l = groupedMasks.filter(mask => { return mask.size == 'l'})
      return {total: groupedMasks.length, s: s.length, m: m.length, l: l.length}
    },
    today() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      if (month <= 9) {
        month = '0' + month;
      }
      let day = new Date().getDate()
      return [year, month, day].join('-')
    },
    toggleTab(tab, i) {
      this.$parent.toggleTab(tab, i)
    },
    getTime(time) {
      if (time && time.seconds) {
        let submitted = new Date(time.seconds*1000)
        return submitted.toLocaleDateString("en-US")
      } else {
        return null
      }
    },
    masksComplete(masks) {
      let complete = true
      masks.forEach(mask=>{
        if (!mask.completed) {
          complete = false
        }
      })
      return complete
    },
    markComplete(i) {
      if (this.res.masks[i].completed) {
        this.res.masks[i].completed = null;
      } else {
        this.res.masks[i].completed = new Date();
      }
      let updatedMasks = [...this.res.masks]
      let path = {
        masks: updatedMasks,
        updated: new Date(),
      }
      reservationsRef.doc(this.res.uuid).update(path).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.res-container {
  .mask-size, .mask-type, .mask-status {
    text-align: center;
  }
  .mask.mask-header {
    font-weight: bold;
  }
  .total-label {
    text-align: right;
  }
  .total {
    text-align: center;
  }
}
</style>
